<template>
    <div class="lnk-table-selectfilter">
		<link-select :data="filters" label-key="name" val-key="field"
					 class="search-field"
					 :width="120"
					 v-model="field"
					 @click="selectField"
					 :placeholder="$t('LnkTableSelectfilter.fieldPlaceholder')"/>
		<link-input v-if="fieldType === 'input'"
					class="search-value"
					:width="200"
					v-model="searchValue"
					@keyup.enter.native="onSearch"
					:placeholder="$t('LnkTableSelectfilter.inputPlaceholder')"/>
		<link-select v-else-if="fieldType === 'select'"
					 class="search-value"
					 :width="200"
					 label-key="name"
					 val-key="val"
					 :data="currentFilter.options || []"
					 v-model="searchValue"
					 @input="onSearch"
					 :placeholder="$t('LnkTableSelectfilter.selectPlaceholder')"/>
		<link-datepicker v-else-if="fieldType === 'date'"
						 :width="200"
						 @change="onSearch"
						 class="search-value"
						 :start.sync="daterange.start"
						 :end.sync="daterange.end" range/>
		<link-button class="search-button"
					 @click="onSearch">查询</link-button>

    </div>
</template>

<script>
import {typeOf} from '@utils/linktools';

export default {
    name: 'lnk-table-selectfilter',
    data(){
        return {

            /* 字段信息*/
            filters: [],

            /* 字段*/
            field: null,

            /* 默认字段*/
            fieldDefault: this.defaultField || null,

            /* 搜索条件*/
            condition: '',

            /* 搜索值*/
            searchValue: '',

            /* 日期范围*/
            daterange: {},

            /* 与之对接的父组件名称*/
            parentName: null,

			/*自定义配置的筛选条件*/
			customOperator: null

		};

    },
    model: {
        event: 'change'
    },
    props: {
        value: Object,
        options: {
            type: Array,
            default(){
                return [];
            }
        },
        defaultField: String
    },
	computed: {
    	/*输入框类型*/
    	fieldType(){
    		let type = 'input';
    		const field = this.field;
    		if(typeOf(field) === 'string' && field){
    			const item = this.filters.find((t)=> t.field === field);
    			if((item.options || []).length){
    				type = 'select';
				}else if(item.type === 'date'){
    				type = 'date';
				}
			}
    		return type;
		},
		/*筛选配置映射*/
		filtersMap(){
			const filtersMap = {};
			this.filters.forEach((t)=> filtersMap[t.field] = t);
			return filtersMap;
		},
		/*当前筛选配置*/
		currentFilter(){
    		return this.filtersMap[this.field] || {};
		}

	},
    watch: {
        defaultField(val){
            if(val && typeOf(val) ==='string'){
                this.fieldDefault = val;
            }
        },
		options(value, oldValue){
        	let isChanged = true;
			try {
				if(JSON.stringify(value)===JSON.stringify(oldValue)){
					isChanged = false;
				}
			}catch (e) {

			}
			if(!isChanged) return;
        	this.initOptions(value);
		}
    },
    methods: {
    	/**
    	 * @createdBy 常九福
    	 * @date 2020/10/26
    	 * @methods: selectField
    	 * @para: item 字段对象
    	 * @description: 获取选择字段信息
    	 **/
		selectField({item}){
			this.customOperator = item.item.customOperator;
		},

        /**
         * @method：initOptions
         * @createdBy：HuangJian
         * @params：
         * @description：初始化筛选条件
         *
         */
        async initOptions(arr) {
			var filters = [];

            if (Array.isArray(arr)) {
                for (var i in arr) {

                    if(typeof arr[i] !=='object') continue;
                    if(arr[i].disabled || arr[i].noSearch) continue;

                    var options = [];

                    /* 自定义筛选项*/
                    if (Array.isArray(arr[i].custom)) {
                        try {
                            options = linkTools.deepCopy(arr[i].custom);
                        } catch (e) {

                        }

                        /* 值列表筛选项*/
                    } else if (arr[i].lov && typeOf(arr[i].lov) === 'string') {
                        try {
                            /*options
                                    = arr[i].parentLov && arr[i].parentLovVal
                                    ?linkLov.getSubLovArray(arr[i].parentLov, arr[i].parentLovVal, arr[i].lov)
                                    : linkLov.getLovArray(arr[i].lov);*/

						  options = arr[i].parentLov && arr[i].parentLovVal
                                    ? await this.$lov.getLovByParentTypeAndValue(arr[i].lov, arr[i].parentLov, arr[i].parentLovVal)
                                    :await this.$lov.getLovByType(arr[i].lov);
                        } catch (e) {

                        }
                    }
                    options = linkTools.deepCopy(options || []);
                    if (arr[i].excludeLov && Array.isArray(arr[i].excludeLov)) {
                        options = linkTools.excludeLov(options, arr[i].excludeLov);
                    }
                    options.forEach((option) => {
                        option.condition = '=';
                    });

                    filters.push({
                        name: arr[i].name,
                        field: arr[i].field,
                        type: arr[i].type || arr[i].lnkType,
                        options: options,
						customOperator: arr[i].customOperator
                    });
                }
            }
			if(filters.length){

                /* 设置默认字段 */
                var isFieldDefaultValid = false;
                for(var j in filters){
                    if(filters[j].field && filters[j].field === this.fieldDefault){
                        isFieldDefaultValid = true;
                        this.customOperator = filters[j].customOperator;
                        break;
                    }
                }
                if(isFieldDefaultValid){
                    this.field = this.fieldDefault;
                }else{
                    this.field = filters[0].field;
					this.customOperator = filters[0].customOperator;
                }
            }
			this.filters = filters;
        },

        /**
         * @method：onSearch
         * @createdBy：HuangJian
         * @params：
         * @description：点击查询
         *
         */
        async onSearch(){
            if(!this.field) return;
            await this.$lv.nextTick()
            const filtersRaw = [];
            if(this.fieldType === 'input'){
            	if(this.searchValue){
            		filtersRaw.push({
						id:`lnk_table_search_${this._uid}`,
						property: this.field,
						operator: this.customOperator ? this.customOperator : 'like',
						value: this.searchValue
					});
				}
			}else if(this.fieldType === 'select'){
				if(this.searchValue){
					filtersRaw.push({
						id:`lnk_table_search_select_${this._uid}`,
						property: this.field,
						operator: this.customOperator ? this.customOperator : '=',
						value: this.searchValue
					});
				}
			}else if(this.fieldType === 'date'){
            	const {start, end} = this.daterange;
            	if(start && end){
					filtersRaw.push({
						id:`lnk_table_search_date_0_${this._uid}`,
						property: this.field,
						operator: '>=',
						value: start
					});
					filtersRaw.push({
						id:`lnk_table_search_date_1_${this._uid}`,
						property: this.field,
						operator: '<=',
						value: end
					});
				}
			}
			this.$emit('search', filtersRaw);
            if(this.parentName){
                this.$dispatch(this.parentName, 'search-change', filtersRaw);
            }
        }
    },
    created(){
        this.$on('setSearchOptions', (arr) => {
            this.initOptions(arr);
        });
        this.$on('setDefaultField', (val) => {
            if(val && typeof val ==='string'){
                this.fieldDefault = val;
            }
        });
        this.$on('setParentName', (val) => {
            if(val && typeof val ==='string'){
                this.parentName = val;
            }
        });
        if(this.SearchOptions || this.options){
            this.initOptions(this.SearchOptions || this.options);
        }
    },
    filters: {

        /**
         * @method：getFormatValue
         * @createdBy：HuangJian
         * @params：
         * @description：
         *
         */
        getFormatValue(value, options){
            var result ='';
            for(var i in options){
                if(options[i].val === value){
                    result = options[i].name;
                }
            }
            return result;
        }
    }
};
</script>

<style lang="scss">
	@include themeify {
		.lnk-table-selectfilter{
			display: inline-flex;
			.search-value{
				margin: 0 -2px;
			}
			.link-input {
				border-color: pl-var(color-info) !important;
				outline: none;
			}
			.link-input {
				.link-input-prefix-icon {
					padding-right: 0 !important;
				}
			}
		}
	}

</style>
